import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "back-button-section" }
const _hoisted_3 = { class: "opportunity-header" }
const _hoisted_4 = { class: "header-top" }
const _hoisted_5 = { class: "header-left" }
const _hoisted_6 = { class: "header-info" }
const _hoisted_7 = {
  key: 0,
  class: "dx-icon-edit edit-hint-icon"
}
const _hoisted_8 = { class: "opportunity-meta" }
const _hoisted_9 = {
  class: "meta-item meta-item--contact",
  title: "Persoană de contact"
}
const _hoisted_10 = {
  class: "meta-item meta-item--account",
  title: "Cont / Partener"
}
const _hoisted_11 = {
  class: "meta-item meta-item--owner",
  title: "Responsabil (Owner)"
}
const _hoisted_12 = {
  class: "meta-item meta-item--date",
  title: "Data creării"
}
const _hoisted_13 = {
  key: 0,
  class: "meta-item meta-item--source",
  title: "Sursă Lead"
}
const _hoisted_14 = { class: "header-actions" }
const _hoisted_15 = { class: "status-path-container" }
const _hoisted_16 = { class: "status-path" }
const _hoisted_17 = ["onClick", "title"]
const _hoisted_18 = { class: "step-label" }
const _hoisted_19 = { class: "banner-content" }
const _hoisted_20 = { class: "banner-text" }
const _hoisted_21 = { class: "finalize-choice-content" }
const _hoisted_22 = { class: "finalize-description-field" }
const _hoisted_23 = { class: "finalize-options" }
const _hoisted_24 = { class: "status-confirmation-content" }
const _hoisted_25 = { class: "confirmation-icon" }
const _hoisted_26 = { class: "confirmation-message" }
const _hoisted_27 = { class: "status-change-info" }
const _hoisted_28 = { class: "status-from" }
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "status-to" }
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "metrics-section" }
const _hoisted_33 = { class: "metric-card" }
const _hoisted_34 = { class: "metric-content" }
const _hoisted_35 = { class: "metric-value" }
const _hoisted_36 = { class: "metric-card" }
const _hoisted_37 = { class: "metric-content" }
const _hoisted_38 = { class: "metric-value-with-bar" }
const _hoisted_39 = { class: "metric-value" }
const _hoisted_40 = { class: "probability-bar-small" }
const _hoisted_41 = { class: "metric-card" }
const _hoisted_42 = { class: "metric-content" }
const _hoisted_43 = { class: "metric-value-with-bar" }
const _hoisted_44 = { class: "metric-value" }
const _hoisted_45 = { class: "probability-bar-small" }
const _hoisted_46 = { class: "metric-card" }
const _hoisted_47 = { class: "metric-content" }
const _hoisted_48 = { class: "metric-value" }
const _hoisted_49 = { class: "two-column-layout" }
const _hoisted_50 = { class: "left-column" }
const _hoisted_51 = { class: "details-card" }
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = { class: "right-column" }
const _hoisted_54 = { class: "section-card" }
const _hoisted_55 = { class: "card-body" }
const _hoisted_56 = { class: "section-card" }
const _hoisted_57 = { class: "card-body" }
const _hoisted_58 = { class: "section-card" }
const _hoisted_59 = { class: "card-body" }
const _hoisted_60 = {
  class: "popup-header",
  style: {"margin":"-16px -20px","padding":"16px 24px","background":"linear-gradient(135deg, #ff2c21 0%, #ff5447 100%)","display":"flex","align-items":"center","gap":"16px"}
}
const _hoisted_61 = { style: {"display":"flex","flex-direction":"column","color":"white","flex":"1"} }
const _hoisted_62 = { style: {"font-size":"16px","font-weight":"700"} }
const _hoisted_63 = {
  class: "popup-body-modern",
  style: {"padding":"0","height":"100%"}
}
const _hoisted_64 = {
  key: 1,
  class: "no-opportunity"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_OpportunityForm = _resolveComponent("OpportunityForm")!
  const _component_CardActivity = _resolveComponent("CardActivity")!
  const _component_CardContacts = _resolveComponent("CardContacts")!
  const _component_CardOferte = _resolveComponent("CardOferte")!
  const _component_CardProducts = _resolveComponent("CardProducts")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!

  return (_openBlock(), _createBlock(_component_DxScrollView, { class: "opportunity-details-container" }, {
    default: _withCtx(() => [
      (_ctx.opportunity)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_DxButton, {
                icon: "arrowleft",
                text: "Înapoi la listă",
                "styling-mode": "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
                class: "back-btn"
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "opportunity-icon" }, [
                    _createElementVNode("i", { class: "dx-icon-box" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["opportunity-title-container", { 'is-editable': _ctx.canEditOpportunity && !_ctx.isCurrentStatusComplete }])
                    }, [
                      (!_ctx.isEditingTitle)
                        ? (_openBlock(), _createElementBlock("h1", {
                            key: 0,
                            class: "opportunity-title",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editTitle && _ctx.editTitle(...args)))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.opportunity.Titlu || 'Oportunitate fără titlu') + " ", 1),
                            (_ctx.canEditOpportunity && !_ctx.isCurrentStatusComplete)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createBlock(_component_DxTextBox, {
                            key: 1,
                            ref: "titleInput",
                            class: "opportunity-title-input",
                            value: _ctx.opportunity.Titlu,
                            placeholder: "Introdu un titlu...",
                            onFocusOut: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveTitle($event))),
                            onEnterKey: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveTitle($event)))
                          }, null, 8, ["value"]))
                    ], 2),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _cache[11] || (_cache[11] = _createElementVNode("i", { class: "dx-icon-card" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.opportunity.Contact
                      ? `${_ctx.opportunity.Contact.Nume ?? ''} ${_ctx.opportunity.Contact.Prenume ?? ''}`.trim()
                      : 'Fără contact'), 1)
                      ]),
                      _createElementVNode("span", _hoisted_10, [
                        _cache[12] || (_cache[12] = _createElementVNode("i", { class: "dx-icon-home" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.opportunity.Account?.Nume || _ctx.opportunity.AccountNume || 'Fără partener'), 1)
                      ]),
                      _createElementVNode("span", _hoisted_11, [
                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "dx-icon-user" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.opportunity.Owner || 'Fără agent'), 1)
                      ]),
                      _createElementVNode("span", _hoisted_12, [
                        _cache[14] || (_cache[14] = _createElementVNode("i", { class: "dx-icon-event" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.opportunity.Data)), 1)
                      ]),
                      (_ctx.opportunity.Sursa?.Nume)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _cache[15] || (_cache[15] = _createElementVNode("i", { class: "dx-icon-link" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.opportunity.Sursa.Nume), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.isCurrentStatusComplete)
                    ? (_openBlock(), _createBlock(_component_DxButton, {
                        key: 0,
                        icon: "refresh",
                        text: "Redeschide Oportunitate",
                        "styling-mode": "outlined",
                        type: "default",
                        class: "reopen-btn",
                        onClick: _ctx.confirmReopen,
                        disabled: _ctx.isUpdatingStatus || !_ctx.canEditOpportunity
                      }, null, 8, ["onClick", "disabled"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusSteps, (step, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(['status-step', _ctx.getStepClass(step, index), { 'clickable': _ctx.canChangeToStatus(step), 'updating': _ctx.isUpdatingStatus }]),
                      onClick: ($event: any) => (_ctx.handleStepClick(step)),
                      title: _ctx.getStepTooltip(step)
                    }, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(step.Nume), 1),
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "step-arrow" }, null, -1))
                    ], 10, _hoisted_17))
                  }), 128))
                ])
              ]),
              (_ctx.isCurrentStatusComplete && _ctx.opportunity.DescriereStatus)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['status-description-banner', _ctx.statusBannerClass])
                  }, [
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "banner-icon" }, [
                      _createElementVNode("i", { class: "dx-icon-info" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "banner-label" }, "Motiv / Descriere Finalizare:", -1)),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.opportunity.DescriereStatus), 1)
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_DxPopup, {
              visible: _ctx.isFinalizePopupVisible,
              "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isFinalizePopupVisible) = $event)),
              "drag-enabled": false,
              "close-on-outside-click": true,
              "show-title": true,
              width: 500,
              height: "auto",
              title: "Finalizare Oportunitate",
              "show-close-button": true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_21, [
                  _cache[23] || (_cache[23] = _createElementVNode("p", { class: "finalize-message" }, "Cum doriți să finalizați această oportunitate?", -1)),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", { class: "field-label" }, [
                      _createElementVNode("i", {
                        class: "dx-icon-edit",
                        style: {"margin-right":"4px","vertical-align":"middle","color":"#3b82f6"}
                      }),
                      _createTextVNode(" Descriere / Motiv: "),
                      _createElementVNode("span", { style: {"color":"#ef4444"} }, "*")
                    ], -1)),
                    _createVNode(_component_DxTextArea, {
                      value: _ctx.finalizeDescription,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.finalizeDescription) = $event)),
                      height: 80,
                      placeholder: "Introduceți un motiv sau o descriere pentru această acțiune (obligatoriu)..."
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", {
                      class: "finalize-option won",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectTerminalStatus('won')))
                    }, [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("div", { class: "option-icon" }, [
                        _createElementVNode("i", { class: "dx-icon-check" })
                      ], -1),
                      _createElementVNode("div", { class: "option-label" }, "Câștigată", -1)
                    ]))]),
                    _createElementVNode("div", {
                      class: "finalize-option lost",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectTerminalStatus('lost')))
                    }, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("div", { class: "option-icon" }, [
                        _createElementVNode("i", { class: "dx-icon-close" })
                      ], -1),
                      _createElementVNode("div", { class: "option-label" }, "Pierdută", -1)
                    ]))])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_component_DxPopup, {
              visible: _ctx.showStatusConfirmation,
              "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showStatusConfirmation) = $event)),
              "drag-enabled": false,
              "close-on-outside-click": true,
              "show-title": true,
              width: 450,
              height: "auto",
              title: "Confirmare Schimbare Status"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.statusChangeIcon),
                      style: _normalizeStyle({ color: _ctx.statusChangeColor })
                    }, null, 6)
                  ]),
                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.statusChangeMessage), 1),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "Status curent:", -1)),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.opportunity?.Status?.Nume || _ctx.opportunity?.Status || '-'), 1)
                    ]),
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "status-arrow" }, [
                      _createElementVNode("i", { class: "dx-icon-arrowright" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_30, [
                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "Status nou:", -1)),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.pendingStatus?.Nume), 1)
                    ])
                  ])
                ]),
                _createVNode(_component_DxToolbarItem, {
                  widget: "dxButton",
                  toolbar: "bottom",
                  location: "after",
                  options: _ctx.confirmButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  widget: "dxButton",
                  toolbar: "bottom",
                  location: "after",
                  options: _ctx.cancelButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[28] || (_cache[28] = _createElementVNode("div", {
                  class: "metric-icon",
                  style: {"background":"#dbeafe"}
                }, [
                  _createElementVNode("i", {
                    class: "dx-icon-money",
                    style: {"color":"#1e40af"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_34, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "metric-label" }, "Buget Estimat", -1)),
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.formatCurrency(_ctx.opportunity.BugetEstimat, _ctx.opportunity.Valuta?.Simbol)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[30] || (_cache[30] = _createElementVNode("div", {
                  class: "metric-icon",
                  style: {"background":"#fef3c7"}
                }, [
                  _createElementVNode("i", {
                    class: "dx-icon-percent",
                    style: {"color":"#78350f"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_37, [
                  _cache[29] || (_cache[29] = _createElementVNode("div", { class: "metric-label" }, "Probabilitate Status", -1)),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.opportunity.Probabilitate || 0) + "%", 1),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", {
                        class: "probability-fill-small",
                        style: _normalizeStyle({ width: (_ctx.opportunity.Probabilitate || 0) + '%', backgroundColor: _ctx.getProbabilityColor(_ctx.opportunity.Probabilitate || 0) })
                      }, null, 4)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _cache[32] || (_cache[32] = _createElementVNode("div", {
                  class: "metric-icon",
                  style: {"background":"#e0e7ff"}
                }, [
                  _createElementVNode("i", {
                    class: "dx-icon-chart",
                    style: {"color":"#3730a3"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_42, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "metric-label" }, "Șansa de Câștig", -1)),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.opportunity.ProbabilitateCastig || 0) + "%", 1),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", {
                        class: "probability-fill-small",
                        style: _normalizeStyle({ width: (_ctx.opportunity.ProbabilitateCastig || 0) + '%', backgroundColor: _ctx.getProbabilityColor(_ctx.opportunity.ProbabilitateCastig || 0) })
                      }, null, 4)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _cache[34] || (_cache[34] = _createElementVNode("div", {
                  class: "metric-icon",
                  style: {"background":"#fecaca"}
                }, [
                  _createElementVNode("i", {
                    class: "dx-icon-event",
                    style: {"color":"#991b1b"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_47, [
                  _cache[33] || (_cache[33] = _createElementVNode("div", { class: "metric-label" }, "Închidere Estimată", -1)),
                  _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.formatDate(_ctx.opportunity.DataInchidereEstimat)), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("div", { class: "card-header-icon" }, [
                      _createElementVNode("i", { class: "dx-icon-doc" })
                    ]),
                    _createElementVNode("h3", { class: "card-header-title" }, "Detalii Oportunitate")
                  ], -1)),
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_OpportunityForm, {
                      "opportunity-data": _ctx.opportunity,
                      "is-editing-prop": false,
                      "is-locked": _ctx.isCurrentStatusComplete,
                      "allow-edit": _ctx.canEditOpportunity,
                      contact: _ctx.listaContacte,
                      parteneri: _ctx.listaParteneri,
                      industrii: _ctx.listaIndustrii,
                      campanii: _ctx.listaCampanii,
                      valute: _ctx.listaValute,
                      surse: _ctx.listaSurse,
                      proiecte: _ctx.listaProiecte,
                      onContactChanged: _ctx.handleContactChange
                    }, null, 8, ["opportunity-data", "is-locked", "allow-edit", "contact", "parteneri", "industrii", "campanii", "valute", "surse", "proiecte", "onContactChanged"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _cache[36] || (_cache[36] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("div", {
                      class: "card-header-icon",
                      style: {"background":"linear-gradient(135deg, #10b981 0%, #34d399 100%)"}
                    }, [
                      _createElementVNode("i", { class: "dx-icon-event" })
                    ]),
                    _createElementVNode("h3", { class: "card-header-title" }, "Activități & Întâlniri")
                  ], -1)),
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_component_CardActivity, {
                      "opportunity-id": _ctx.opportunity?.ID,
                      "opportunity-data": _ctx.opportunity,
                      "is-locked": _ctx.isCurrentStatusComplete || !_ctx.canEditOpportunity
                    }, null, 8, ["opportunity-id", "opportunity-data", "is-locked"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("div", {
                      class: "card-header-icon",
                      style: {"background":"linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)"}
                    }, [
                      _createElementVNode("i", { class: "dx-icon-group" })
                    ]),
                    _createElementVNode("h3", { class: "card-header-title" }, "Contacte")
                  ], -1)),
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_CardContacts, {
                      "partener-id": _ctx.opportunity?.AccountID,
                      "highlight-contact-id": _ctx.opportunity?.ContactID,
                      "allow-contact-selection": !_ctx.isCurrentStatusComplete && _ctx.canEditOpportunity,
                      onContactSelected: _ctx.handleContactChange,
                      contact: _ctx.listaContacte
                    }, null, 8, ["partener-id", "highlight-contact-id", "allow-contact-selection", "onContactSelected", "contact"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _cache[38] || (_cache[38] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("div", {
                      class: "card-header-icon",
                      style: {"background":"linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)"}
                    }, [
                      _createElementVNode("i", { class: "dx-icon-box" })
                    ]),
                    _createElementVNode("h3", { class: "card-header-title" }, "Oferte")
                  ], -1)),
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_CardOferte, {
                      "opportunity-id": _ctx.opportunity?.ID,
                      "opportunity-data": _ctx.opportunity,
                      onShowProducts: _ctx.onShowProducts,
                      "is-locked": _ctx.isCurrentStatusComplete || !_ctx.canEditOpportunity
                    }, null, 8, ["opportunity-id", "opportunity-data", "onShowProducts", "is-locked"])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_DxPopup, {
              visible: _ctx.isProductsPopupVisible,
              "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isProductsPopupVisible) = $event)),
              "drag-enabled": true,
              "close-on-outside-click": false,
              "show-title": true,
              width: 1400,
              height: 600,
              "hide-on-outside-click": false,
              "show-close-button": true
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_60, [
                  _cache[40] || (_cache[40] = _createElementVNode("span", {
                    class: "dx-icon-box",
                    style: {"font-size":"24px","width":"45px","height":"45px","display":"flex","align-items":"center","justify-content":"center","border-radius":"8px","color":"white","background":"rgba(255,255,255,0.2)"}
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("span", _hoisted_62, "Produse Ofertă: " + _toDisplayString(_ctx.selectedOffer?.Nume), 1),
                    _cache[39] || (_cache[39] = _createElementVNode("span", { style: {"font-size":"12px","opacity":"0.9"} }, "Vizualizează și gestionează produsele din această ofertă", -1))
                  ]),
                  _createVNode(_component_DxButton, {
                    icon: "close",
                    "styling-mode": "text",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isProductsPopupVisible = false)),
                    "element-attr": { style: 'color: white !important; background: rgba(255,255,255,0.1); border-radius: 8px;' }
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_63, [
                  (_ctx.isProductsPopupVisible && _ctx.selectedOffer?.ID)
                    ? (_openBlock(), _createBlock(_component_CardProducts, {
                        key: 0,
                        "opportunity-id": _ctx.opportunity?.ID,
                        "opportunity-data": _ctx.opportunity,
                        "offer-id": _ctx.selectedOffer?.ID,
                        "auto-add": _ctx.isAutoAddTriggered,
                        "is-locked": _ctx.isCurrentStatusComplete || !_ctx.canEditOpportunity
                      }, null, 8, ["opportunity-id", "opportunity-data", "offer-id", "auto-add", "is-locked"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_64, [...(_cache[41] || (_cache[41] = [
            _createElementVNode("div", { class: "no-opportunity-icon" }, [
              _createElementVNode("i", { class: "dx-icon-box" })
            ], -1),
            _createElementVNode("p", { class: "no-opportunity-text" }, "Nicio oportunitate selectată", -1),
            _createElementVNode("p", { class: "no-opportunity-subtext" }, "Selectează o oportunitate din listă pentru a vedea detaliile", -1)
          ]))]))
    ]),
    _: 1
  }))
}